<template>
  <el-button size="mini" type="danger" plain @click="onSubmit">
    Delete
  </el-button>
</template>

<script>
export default {
  props: {
    categoryId: String,
  },
  methods: {
    async onSubmit() {
      try {
        await this.$confirm('The category will be permanently deleted.', 'Confirm Delete', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
      } catch(err) {
        return false
      }
      try {
        var { data } = await this.$http.delete(`/categories/${ this.categoryId }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.$emit('delete')
      this.$message.success(data.message)
    },
  },
}
</script>
